import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  return (
    <nav className="main-nav">
      <div className="nav-links">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/new-memory" className="nav-link">Create Memory</Link>
        <Link to="/past-memories" className="nav-link">Past Memories</Link>
        <Link to="/memory-regeneration" className="nav-link">Memory Training</Link>
        <Link to="/enhanced-journaling" className="nav-link">Enhanced Journaling</Link>
        <Link to="/mind-palace" className="nav-link">Mind Palace</Link>
      </div>
    </nav>
  );
};

export default Navigation; 